import "./ContentManagement.scss";
import React, { useState } from "react";

const ContentManagementTabs = ({ setPropertyTab, propertyTab }) => {
  return (
    <>
      <div className="student_management">
        <div className="wrapper_cstm_tabers" style={{ marginBottom: "20px" }}>
          <ul style={{ paddingLeft: "0px" }}>
            <li
              className={propertyTab === "en" ? "active" : ""}
              onClick={() => setPropertyTab("en")}
            >
              English
            </li>

            <li
              className={propertyTab === "ru" ? "active" : ""}
              onClick={() => setPropertyTab("ru")}
            >
              Russian
            </li>
            <li
              className={propertyTab === "es" ? "active" : ""}
              onClick={() => setPropertyTab("es")}
            >
              Spanish
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default ContentManagementTabs;
